import Lenis from 'lenis';
import gsap from 'gsap';

export class Interactions {
  constructor () {
    this.lenis = null;
  }

  createSmoothScroll () {
    this.lenis = new Lenis({
      lerp: 0.08,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    });

    this.lenis.on('scroll', () => {
      // // console.log('smooth scroll');
    });

    gsap.ticker.add(time => {
      this.lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }

  stopLenis () {
    this.lenis.stop();
  }

  startLenis () {
    this.lenis.start();
  }

  destroyLenis () {
    this.lenis.stop();
    this.lenis.destroy();
  }

  scrollTo (el) {
    this.lenis.scrollTo(el);
  }
}
